// extracted by mini-css-extract-plugin
export default {"deleteText":"OpenPositionsDeleteAllModal_deleteText__w8fHt","deleteSure":"OpenPositionsDeleteAllModal_deleteSure__pChMp"};